import React from 'react';

/**
 * KDS chip. `variant` maps a semantic role onto a chip modifier; unknown
 * variants degrade to the neutral chip rather than losing their styling.
 */
const VARIANTS = {
  accent: 'kds-chip--accent',
  tertiary: 'kds-chip--tertiary',
  river: 'kds-chip--tertiary',
  status: 'kds-chip--warning',
  warning: 'kds-chip--warning',
  outline: 'kds-chip--outline',
};

export default function Badge({ variant, className = '', children }) {
  const modifier = VARIANTS[variant] || '';
  return <span className={`kds-chip ${modifier} ${className}`.replace(/\s+/g, ' ').trim()}>{children}</span>;
}
